<template lang="html">
  <div id="app">
    <div class="w-full flex flex-row-reverse flex-wrap h-screen md:overflow-hidden">
      <div class="w-full md:w-1/2 h-auto md:h-full">
        <div class="flex flex-col items-center h-full w-full">
          <img :src="`${require('images/login_logo_reset.png')}`" class="w-full h-auto md:h-full object-contain">
        </div>
      </div>
      <div class="w-full md:w-1/2 bg-white h-auto md:h-full py-20 p-6 md:overflow-y-auto">
        <div class="flex items-center justify-center w-full mt-4">
          <a href="/"><img :src="`${require('images/reset_youreveryday_logo.png')}`" class="h-16"></a>
        </div>



        <div class="flex flex-wrap w-full mt-12">
          <!-- <div v-for="(type, index) in types" :key="type.name" class="flex justify-center items-center cursor-pointer px-8 py-3 w-2/5 mx-auto min-wd-150 max-wd-220 mb-4 xs:mb-0" :class="selected_type == type.name ? 'rs-filter-btn' : 'cursor-pointer fs-lightgrey-btn'" @click="selectType(type)">
            <inline-svg :src="type.icon" class="flex-shrink-0 w-5 md:w-6 h-5 md:h-6 object-cover" :stroke="selected_type== type.name ? 'white' : '#A9A9A9'"></inline-svg><span class="ml-1 md:ml-2" :class="selected_type== type.name ? 'text-2' : 'text-1'">{{ type.name}}</span>
          </div> -->
        </div>

        
        <!-- <div class="flex flex-wrap w-full mt-16">
          <div v-for="(type, index) in types" :key="type.name" class="flex justify-center items-center cursor-pointer px-8 py-3 w-2/5 mx-auto min-wd-150 max-wd-220 mb-4 xs:mb-0" :class="selected_type == type.name ? 'rs-filter-btn' : 'cursor-pointer fs-lightgrey-btn'" @click="selectType(type)">
            <inline-svg :src="type.icon" class="flex-shrink-0 w-5 md:w-6 h-5 md:h-6 object-cover" :stroke="selected_type== type.name ? 'white' : '#A9A9A9'"></inline-svg><span class="ml-1 md:ml-2" :class="selected_type== type.name ? 'text-2' : 'text-1'">{{ type.name}}</span>
          </div>
        </div> -->

        <!-- <div class="flex flex-wrap w-full mt-4">
          <div v-for="(type, index) in types_1" :key="type.name" class="flex justify-center items-center cursor-pointer px-8 py-3 w-2/5 mx-auto min-wd-150 max-wd-220 mb-4 xs:mb-0" :class="selected_type == type.name ? 'rs-filter-btn' : 'cursor-pointer fs-lightgrey-btn'" @click="selectType(type)">
            <inline-svg :src="type.icon" class="flex-shrink-0 w-5 md:w-6 h-5 md:h-6 object-cover" :stroke="selected_type== type.name ? 'white' : '#A9A9A9'"></inline-svg><span class="ml-1 md:ml-2" :class="selected_type== type.name ? 'text-2' : 'text-1'">{{ type.name}}</span>
          </div>
        </div> -->

        <div>
          <component :is="selected_tab"></component>
        </div>


        <div class="bg-white inline-flex mb-8 mt-12 xs:mt-16 rounded-lg w-full text-center border-b border-darkgrey">
          <div v-for="(tab) in tabs" :id="tab.name" class="font-semibold text-sm px-6 pb-4 cursor-pointer hover:text-blue w-1/2" @click="selectTab(tab)" :class="selected_tab==tab.component ? ' border-b-2 border-rspurple' : ''">
            {{tab.name}}
          </div>
        </div>

        <div v-if="this.selected_tab == 'signup' && this.show_top_section === true">
          <div class="">
            <div class="mt-20 text-center">
              <label class="font-bold text-md">Enter your join code</label>
              <div class="my-3 flex justify-center">
                <input v-model="stadium_code.code_1" required class="join-input-sm xs:join-input sm:join-input-sm md:join-input" type="text" maxlength="1" pattern="[A-Za-z0-9]{1}" @input="moveToNextInput" @paste="paste" autofocus>
                <input v-model="stadium_code.code_2" required class="join-input-sm xs:join-input sm:join-input-sm md:join-input" type="text" maxlength="1" pattern="[A-Za-z0-9]{1}" @input="moveToNextInput" @paste="paste" autofocus>
                <input v-model="stadium_code.code_3" required class="join-input-sm xs:join-input sm:join-input-sm md:join-input" type="text" maxlength="1" pattern="[A-Za-z0-9]{1}" @input="moveToNextInput" @paste="paste">
                <input v-model="stadium_code.code_4" required class="join-input-sm xs:join-input sm:join-input-sm md:join-input" type="text" maxlength="1" pattern="[A-Za-z0-9]{1}" @input="moveToNextInput" @paste="paste">
                <input v-model="stadium_code.code_5" required class="join-input-sm xs:join-input sm:join-input-sm md:join-input" type="text" maxlength="1" pattern="[A-Za-z0-9]{1}" @input="moveToNextInput" @paste="paste">
                <input v-model="stadium_code.code_6" required class="join-input-sm xs:join-input sm:join-input-sm md:join-input" type="text" maxlength="1" pattern="[A-Za-z0-9]{1}" @input="moveToNextInput" @paste="paste">
              </div>

              <div class="mx-auto items-center justify-center mt-20">
                <button @click.prevent="onContinue()" class="" :class="stadiumInfo == null ? 'fs-darkgrey-btn cursor-none' : 'rs-purple-btn cursor-pointer'">Continue</button>
              </div>
            </div>
          </div>
        </div>

        <div v-if="selected_tab == 'signin'">
          <sign-in
            :stadium_code="stadium_join_code"
            :stadiumInfo="stadiumInfo"
          ></sign-in>
        </div>

        <div v-if="selected_tab === 'signup' && this.proceed_to_signup === true">
          <sign-up
            :stadium_code="prepared_stadium_code"
            :stadiumInfo="stadiumInfo"
            :resource="resource"
            :invitation_token="invitation_token"
          ></sign-up>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  import axios from 'axios';
  import SignUp from "./registrations/new";
  import SignIn from "./session/new";
  import InlineSvg from 'vue-inline-svg';


  export default {
    components: {
      SignUp,
      SignIn,
      InlineSvg
    },
    props: {
      resource: Object,
      invitation_token: String,
      type: String,
    },
    data() {
      return {
        user: {},
        proceed_to_signup: false,
        stadiumInfo: null,
        selected_tab: 'signin',
        selected_type: 'Organization',
        authenticity_token: null,
        stadium_enter_as: null,
        show_top_section: false,
        types: [{name: "Organization",icon: require('images/dashboard/organizations.svg')},{ name: "Author", icon: require('images/dashboard/author.svg')}],
        // types_1: [{name: "Expert",icon: require('images/dashboard/expert.svg')},{ name: "Host", icon: require('images/dashboard/host.svg')}],
        tabs: [{ component: "signin", name: "Log in"},{ component: "signup", name: "Activate account"}],
        stadium_code: {
          code_1: null,
          code_2: null,
          code_3: null,
          code_4: null,
          code_5: null,
          code_6: null,
          code_7: null
        },
        no_stadium_found: false,
      }
    },
    validations: {
    },
    created(){
    },
    mounted() {
      this.authenticity_token = document.getElementsByName('csrf-token')[0].getAttribute('content');

      if(this.resource && this.invitation_token){
        this.selected_tab = 'signup'
        this.getStadiumInfo();
      }

      if(this.type){
        this.selected_tab = this.type;
      }
    },
    computed:{
      prepared_stadium_code: function() {
        return `${this.stadium_code.code_1}${this.stadium_code.code_2}${this.stadium_code.code_3}${this.stadium_code.code_4}${this.stadium_code.code_5}${this.stadium_code.code_6}`
      }
    },
    methods: {
      getStadiumInfo(){
        if(this.resource){
          var data = {
            user_id: JSON.parse(this.resource).id,
          }
        }else if(this.stadium_join_code){
          var data = {
            stadium_code: this.stadium_join_code
          }
        }
        axios({
          method: 'post',
          headers: {
            "Accept": 'application/vnd.reset+json;version=1',
            "X-CSRF-Token": document.getElementsByName('csrf-token')[0].getAttribute('content')
          },
          url: '/api/users/stadium_info',
          data: data,
        }).then((response) => {
          if(Object.entries(response).length > 0 && response.data.data){
            this.stadiumInfo = response.data.data;
            if(response.data.data){
              this.stadium_enter_as = 'Join the organization';
            }
          }else{
            if(this.stadium_join_code.length > 0){
              $("#stadium_info").html("Invalid Code");
            }else{
              $("#stadium_info").html("");
            }
          }
        })
        .catch((error) => {
        });
      },

      getStadiumInfo(){
        axios({
          method: 'post',
          headers: {
            "Accept": 'application/vnd.reset+json;version=1',
            "X-CSRF-Token": document.getElementsByName('csrf-token')[0].getAttribute('content')
          },
          url: '/api/users/stadium_info',
          data: {
            stadium_code: this.prepared_stadium_code,
          }
        }).then((response) => {
          if(response.data.data){
            this.no_stadium_found = false;
            // this.stadiumInfo = response.data.data;
            this.stadiumInfo = response.data.data;
            this.is_join_another = true;
          }else{
            this.no_stadium_found = true;
          }
        })
        .catch((error) => {
        });
      },
      fetchStadiumInfo(){
        if(this.stadium_join_code.length == 7){
          this.getStadiumInfo();
        }else{
          this.stadiumInfo = null;
        }
      },
      clearStadiumInfo(){
        this.stadium_join_code = "";
        this.stadiumInfo = null;
        $("#stadium_info").html("");
      },
      selectTab(tab) {
        this.selected_tab = tab.component
      },
      selectType(type){
        this.selected_type = type.name
      },
      onContinue(){
        if (this.stadiumInfo != null && this.stadiumInfo.code_used == false){
          this.proceed_to_signup = true;
          this.show_top_section = false;
        }else{
          this.$swal({
            html: "<p>You’ve already signed up! Forgot your password? Reset your password here <span><a href='/users/password/new' style='color:#8B40E2' class='underline'>Forgot your password?</a></span></p>",
            type: "warning",
          });
          this.clearJoinCode();
        }
      },

      clearJoinCode(){
        this.stadium_code.code_1 = null;
        this.stadium_code.code_2 = null;
        this.stadium_code.code_3 = null;
        this.stadium_code.code_4 = null;
        this.stadium_code.code_5 = null;
        this.stadium_code.code_6 = null;
        this.stadium_code.code_7 = null;      
      },

      moveToNextInput(event) {
        if (event.data) {
          if (event.target.nextElementSibling) {
            event.target.nextElementSibling.focus()
          }
        }
        if(this.stadium_code.code_1 && this.stadium_code.code_2 && this.stadium_code.code_3 && this.stadium_code.code_4 && this.stadium_code.code_5 && this.stadium_code.code_6){
          this.getStadiumInfo()
        }
      },
      autoFillCodePaste(code){
        if (code){
          this.stadium_code.code_1 = code[0]
          this.stadium_code.code_2 = code[1]
          this.stadium_code.code_3 = code[2]
          this.stadium_code.code_4 = code[3]
          this.stadium_code.code_5 = code[4]
          this.stadium_code.code_6 = code[5]
          this.stadium_code.code_7 = code[6]
        };
      },
      paste(event) {
        this.autoFillCodePaste(event.clipboardData.getData('text'))
      }
    }
};
</script>

<style lang="scss" scoped>
.-mb-18{
  margin-bottom: -4.5rem;
}

.fs-blue-btn {
  @apply bg-gradient-r-blue text-center py-2 px-6 rounded-full cursor-pointer outline-none font-semibold text-sm border-0;
  min-width:auto;
}

.fs-back-btn {
  @apply bg-lightgrey rounded-full w-8 h-8 flex text-white font-semibold justify-center items-center cursor-pointer;
  min-width:auto;
}

.fs-darkgrey-btn {
  @apply bg-darkgrey text-center text-white py-2 px-6 rounded-full cursor-pointer outline-none font-semibold text-sm;
  min-width:auto;
}

.fs-tabs-header .fs-tabs-nav ul, .fs-tabs-header .fs-tabs-nav ul li.active{
  color: white !important;
}

.fs-tabs-header{
  align-items: baseline !important;
}

.h-95{
  height: 95%;
}

.text-1{
  font-family: "SofiaPro-Medium";
  font-size: 16px;
}

.text-2{
  font-family: "SofiaPro-Medium";
  font-size: 16px;
  color: white !important;
}

@responsive {
  .lg-max-width-720 {
    max-width: 720px;
  }
  .lg-max-height-827 {
    max-height: 827px;
  }
  .top-325 {
    top: 325px;
  }
  .join-input {
    @apply w-16 mr-2 outline-none text-2xl text-darkblue text-center bg-lightgrey h-16 font-bold;
  }
  .join-input-sm {
    @apply w-12 mr-2 outline-none text-2xl text-darkblue text-center bg-lightgrey h-12 font-bold;
  }
  .min-wd-150 {
    min-width: 150px;
  }
  .max-wd-220 {
    max-width: 220px;
  }
}
</style>
